import * as React from 'react'
import * as dayjs from 'dayjs'

import { ChevronDownIcon } from '@/app/features/icons/ChevronDown'

type Props = {
  settlementMonth: string
  disabled?: boolean
  goToPrevMonth: () => void
  goToNextMonth: () => void
  selectedMonth: dayjs.Dayjs
  maxMonth?: dayjs.Dayjs
}

export const MonthNavigator = ({
  settlementMonth,
  goToPrevMonth,
  goToNextMonth,
  selectedMonth,
  maxMonth,
}: Props) => {
  const isNextDisabled = maxMonth
    ? !selectedMonth.isBefore(maxMonth, 'month')
    : !selectedMonth.isBefore(dayjs(), 'month')

  return (
    <div className="tw-flex tw-gap-3 tw-border-b tw-border-base-300 tw-p-4">
      <div className="tw-flex tw-items-center tw-gap-2">
        <button
          className="tw-m-0.5 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center"
          onClick={goToPrevMonth}
        >
          <ChevronDownIcon className="tw-h-4 tw-rotate-90" />
        </button>
        <button
          className={
            'tw-m-0.5 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center disabled:tw-opacity-50'
          }
          onClick={goToNextMonth}
          disabled={isNextDisabled}
        >
          <ChevronDownIcon className="tw-h-4 -tw-rotate-90" />
        </button>
      </div>
      <p className="tw-mb-0 tw-text-2xl tw-font-bold">{settlementMonth}</p>
    </div>
  )
}
